module.exports = __webpack_public_path__ + "static/bradesco-4-0a33c68e0d3434628a4f16b61b93149c.jpg";